export default {
  SKILLS_INVENTORY: 'skills_inventory',
  REQUIRED_OCCUPATIONS: 'required_occupations',
}
